/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import ApplicationWizard from '../components/ApplicationWizard';
import ContentBlock from '../components/ContentBlock';
import Footer from '../components/Footer';
import GraphQLConnectedDemo from '../components/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../components/GraphQL-IntegratedDemo';
import GraphQLLayout from '../components/GraphQL-Layout';
import HeroBanner from '../components/HeroBanner';
import OdooSettingsProvider from '../components/OdooSettingsProvider';
import StyleguideComponentParams from '../components/Styleguide-ComponentParams';
import StyleguideCustomRouteType from '../components/Styleguide-CustomRouteType';
import StyleguideFieldUsageCheckbox from '../components/Styleguide-FieldUsage-Checkbox';
import StyleguideFieldUsageContentList from '../components/Styleguide-FieldUsage-ContentList';
import StyleguideFieldUsageCustom from '../components/Styleguide-FieldUsage-Custom';
import StyleguideFieldUsageDate from '../components/Styleguide-FieldUsage-Date';
import StyleguideFieldUsageFile from '../components/Styleguide-FieldUsage-File';
import StyleguideFieldUsageImage from '../components/Styleguide-FieldUsage-Image';
import StyleguideFieldUsageItemLink from '../components/Styleguide-FieldUsage-ItemLink';
import StyleguideFieldUsageLink from '../components/Styleguide-FieldUsage-Link';
import StyleguideFieldUsageNumber from '../components/Styleguide-FieldUsage-Number';
import StyleguideFieldUsageRichText from '../components/Styleguide-FieldUsage-RichText';
import StyleguideFieldUsageText from '../components/Styleguide-FieldUsage-Text';
import StyleguideLayout from '../components/Styleguide-Layout';
import StyleguideLayoutReuse from '../components/Styleguide-Layout-Reuse';
import StyleguideLayoutTabs from '../components/Styleguide-Layout-Tabs';
import StyleguideLayoutTabsTab from '../components/Styleguide-Layout-Tabs-Tab';
import StyleguideMultilingual from '../components/Styleguide-Multilingual';
import StyleguideRouteFields from '../components/Styleguide-RouteFields';
import StyleguideSection from '../components/Styleguide-Section';
import StyleguideSitecoreContext from '../components/Styleguide-SitecoreContext';
import StyleguideTracking from '../components/Styleguide-Tracking';
import TrackingPixel from '../components/TrackingPixel';

const components = new Map();
components.set('ApplicationWizard', ApplicationWizard);
components.set('ContentBlock', ContentBlock);
components.set('Footer', Footer);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('HeroBanner', HeroBanner);
components.set('OdooSettingsProvider', OdooSettingsProvider);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Tracking', StyleguideTracking);
components.set('TrackingPixel', TrackingPixel);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
